import { overflow } from "@prismicio/editor-support/String"
import { SelectItem } from "@prismicio/editor-ui"

import { useRequestRepositoryCustomTypes } from "../../../hooks/useRequestRepositoryCustomTypes"
import { useAPIExplorer } from "../../APIExplorerContext"
import { RequestFormInput } from "./RequestFormInput"
import { RequestFormSelect } from "./RequestFormSelect"

/**
 * Display a fieldset managing a request document type setting.
 */
export function RequestTypeFieldset(props: { nonRepeatableOnly?: boolean }) {
  const { nonRepeatableOnly } = props

  const repositoryTypes = useRequestRepositoryCustomTypes(nonRepeatableOnly)

  const { request } = useAPIExplorer()

  function setType(type: string) {
    request.setRequestOptions(request.type, {
      ...request.options[request.type],
      type,
    })
  }

  if (repositoryTypes.length === 0) {
    return (
      <RequestFormInput
        value={request.options[request.type]?.["type"] ?? ""}
        onValueChange={setType}
        label="TYPE *"
        placeholder="page"
        error={!request.options[request.type]?.["type"]}
      />
    )
  }

  if (!request.options[request.type]?.["type"] && repositoryTypes[0]) {
    setType(repositoryTypes[0].id)
  }

  return (
    <RequestFormSelect
      label="TYPE *"
      value={request.options[request.type]?.["type"] ?? ""}
      onValueChange={setType}
      placeholder="page"
    >
      {repositoryTypes.map(({ id }) => (
        <SelectItem key={id} value={id}>
          {overflow(id, 60)}
        </SelectItem>
      ))}
    </RequestFormSelect>
  )
}
